import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollIntoViewWithinContainer } from '../utils/scroll';

/**
 * Хук: при изменении URL hash (`#<id>`) прокручивает элемент с таким `id`
 * в видимую область его собственной области прокрутки — страница при этом не двигается.
 * Значение hash декодируется через `decodeURIComponent`.
 *
 * Поведение:
 * - hash пустой → ничего не делает;
 * - элемент не найден → ничего не делает;
 * - элемент найден → прокрутка области к началу элемента.
 *
 * Учитывайте `scroll-margin-top` на якорной секции, чтобы заголовок не упирался
 * в верх скроллящегося контейнера.
 *
 * @param enabled Выключатель: при `false` хук игнорирует hash. Удобно для
 *                страниц, где hash используется для других целей.
 */
export const useHashScroll = (enabled = true): void => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!enabled || !hash) return;
    const id = decodeURIComponent(hash.slice(1));
    if (!id) return;
    scrollIntoViewWithinContainer(document.getElementById(id), { behavior: 'smooth' });
  }, [hash, enabled]);
};
